import clsx from 'clsx';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { IoMdSearch } from 'react-icons/io';
import DrawerSkeleton from '../..';
import { PersonIcon } from '../../../Assets/icons';
import CommonCard from '../../../Components/General/CommonCard';
import LinkList from '../../../Components/General/LinkPatient/LinkList';
import NoDataFound from '../../../Components/General/NoDataFound';
import Button from '../../../Components/UI/Button';
import DatePickerPopup from '../../../Components/UI/DatePickerPopup';
import { Input } from '../../../Components/UI/Input';
import MiniLoader from '../../../Components/UI/MiniLoader';
import useDebounce from '../../../CustomHooks/useDebounce';
import usePatient from '../../../Features/usePatient';
import DrawerHeader from '../../DrawerHeader';
import CreatePatientDrawer from '../../PatientDrawer/CreatePatientDrawer';
import CreateAppointmentDetailDrawer from '../CreateAppointmentDetailDrawer';
import CreatePatientAndAppointmentDrawer from '../../CreatePatientAndAppointment';
import classes from './CreateAppointmentDrawer.module.css';
const CreateAppointmentDrawer = ({ show, setShow }) => {
  const [showCreatePatientDrawer, setShowCreatePatientDrawer] = useState(false);
  const [showCreateAppointmentDrawer, setShowCreateAppointmentDrawer] = useState(false);
  const [searchByName, setSearchByName] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const searchDebounce = useDebounce(searchByName, 600);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const {
    linkOrAddPatient,
    getAllExistingPatients,
    loading,
    existingPatients,
    setExistingPatients
  } = usePatient();
  const toggleCreatePatientDrawer = () => {
    setShowCreatePatientDrawer((currentState) => !currentState);
  };

  useEffect(() => {
    if (searchDebounce) {
      // getAllExistingPatients({
      //   patientName: searchDebounce,
      //   patientCellNo: '',
      //   patientEMRNo: ''
      // });
      getAllExistingPatients({
        ...(typeof searchDebounce === 'string' &&
          /^[a-zA-Z\s]+$/.test(searchDebounce) && { patientName: searchDebounce }), // If searchDebounce is alphabetical
        ...(typeof searchDebounce === 'string' &&
          /^(\+?\d+)$/.test(searchDebounce) && { patientCellNo: searchDebounce }), // If searchDebounce is a number or starts with +
        patientEMRNo: ''
      });
    } else {
      setSelectedItem(null);
      setExistingPatients([]);
    }
  }, [searchDebounce]);
  const toggleAppointmentDrawer = () => {
    setShowCreateAppointmentDrawer((current) => !current);
  };
  const onToggleDrawer = () => {
    setExistingPatients([]);
    setSearchByName('');
    setSelectedItem(null);
    setShow();
  };
  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          onToggleDrawer();
        }}>
        <DrawerHeader
          prev={false}
          title={'Create Appointment'}
          show={show}
          setShow={() => {
            onToggleDrawer();
          }}
        />
        <section className={clsx(classes.wrapper, 'scrollbar1')}>
          <div className={classes.dateSelectorWrapper}>
            <span className={classes.selectedDate}>
              {moment(selectedDate).format('DD MMMM YYYY')}
            </span>
            <DatePickerPopup setter={setSelectedDate} />
          </div>
          <div className={classes.actionWrapper}>
            <Input
              className={classes.globalSearch}
              value={searchByName}
              setter={setSearchByName}
              placeholder="Search Name or Phone"
              rightIcon={
                <span className={classes.inputRightIcon}>
                  <IoMdSearch size={22} color="var(--icon-color)" />
                </span>
              }
            />
            <Button
              leftIcon={<PersonIcon color="var(--primary-color)" />}
              variants="view"
              label="Add New Patient"
              className={classes.calendarButton}
              onClick={() => {
                setSelectedItem(null);
                toggleCreatePatientDrawer();
                setShow();
              }}
            />
          </div>
          {!loading ? (
            <>
              {existingPatients?.length > 0 ? (
                <ul className={classes.listWrapper}>
                  {existingPatients?.map((data) => (
                    <CommonCard Tag="li" className={classes.linkCard} key={data?.id}>
                      <LinkList
                        data={data}
                        setSelectedItem={setSelectedItem}
                        className={classes.avoidBorderBottom}
                        onCreateAppointment={() => {
                          toggleAppointmentDrawer();
                          setShow();
                        }}
                      />
                    </CommonCard>
                  ))}
                </ul>
              ) : (
                <NoDataFound label="No Patient Found" />
              )}
            </>
          ) : (
            <MiniLoader />
          )}
          <div className={classes.bottomAction}>
            <Button
              label={'Close'}
              variants="secondary"
              onClick={() => {
                onToggleDrawer();
              }}
            />
          </div>
        </section>
      </DrawerSkeleton>
      {/* <CreatePatientDrawer
        setShow2={setShow}
        cellNumber={searchByName}
        show={showCreatePatientDrawer}
        data={selectedItem}
        selectedDate={selectedDate}
        onSubmit={linkOrAddPatient}
        setShow={() => {
          toggleCreatePatient();
          setExistingPatients([]);
          setSearchByName('');
        }}
      /> */}

      <CreatePatientAndAppointmentDrawer
        setShow2={setShow}
        cellNumber={searchByName}
        show={showCreatePatientDrawer}
        data={selectedItem}
        selectedDate={selectedDate}
        onSubmit={linkOrAddPatient}
        setShow={() => {
          toggleCreatePatientDrawer();
          setExistingPatients([]);
          setSearchByName('');
        }}
      />

      <CreateAppointmentDetailDrawer
        show={showCreateAppointmentDrawer}
        setShow2={setShow}
        setShow={() => {
          toggleAppointmentDrawer();
          setExistingPatients([]);
          setSearchByName('');
        }}
        data={{
          ...selectedItem,
          patientName: selectedItem?.name,
          countryCode: selectedItem?.cellNumber?.slice(0, 3),
          cellNumber: selectedItem?.cellNumber?.slice(3)
        }}
      />
    </>
  );
};

export default CreateAppointmentDrawer;
